import { FigPalette } from '@/ui/theme/tokens/fig/fig-palette';

export const C = {
  Divider: FigPalette.Grey.$200,
  Border: FigPalette.Grey.$300,
  Text: FigPalette.Grey.$900,
  TextOnDark: 'white',
  Label: FigPalette.Grey.$400,
  Good: FigPalette.Pistachio.$500,
  GoodDark: FigPalette.Pistachio.$700,
  Warn: FigPalette.Orange.$500,
  WarnDark: FigPalette.Orange.$700,
  Bad: FigPalette.Watermelon.$500,
  BadDark: FigPalette.Watermelon.$700,
};

export function percentageToColor(value: number, benchmark: number = 100) {
  if (value < 50) {
    return C.Bad;
  }
  if (value < benchmark) {
    return C.Warn;
  }
  return C.Good;
}
